<div class="hospital-admittance-container">
  <div *ngIf="!claim.isHKGorHGI()" class="prev-bar">
    <a (click)="back()" style="color: #0064c1" class="btn new-btn btn-secondary"><em class="fas fa-arrow-left"></em> {{ 'claimSection.generalLabels.generalButtonLabels.back' | translate}} </a>
  </div>
  <div *ngIf="!claim.isHKGorHGI()" class="col-12">
    <h5>{{ 'paClaim.accidentalMedicalExpenses.title1' | translate }}</h5>
    <br>
  </div>
  <div class="row col-12">
    <div class="col-lg-12 col-md-12">
      <form>
        <div class="form-group">
          <qnect-ui #PA_WAS_ADMITTED [fieldId]="'PA_WAS_ADMITTED'" [formGroup]="ameForm" name="wasAdmitted"></qnect-ui>
        </div>
         <!-- bubble depreciation info -->
        <div *ngIf="this.claimPA.getAccidentalMedicalExpenses().getWasAdmitted()">
          <div class="form-group dept-del-info col-xl-6 col-xs-12 col-md-8 hospital-admittance-info-row-container">
            <div class="row col-12 col-md-12 hospital-admittance-info-row">
              <div *ngIf="!claim.isMox()" class="col-3 col-md-2 percent-text"> <img class="icon" style="width: 50px;height: 50px;" src="assets/images/hospital-cash-blue.svg" alt=""> </div>
              <div *ngIf="claim.isMox()" class="col-3 col-md-2 percent-text"> <img class="icon" style="width: 50px;height: 50px;" src="assets/images/hospital-cash-black.svg" alt=""> </div>
              <div class=" col-9 col-md-10 dept-desc-text">{{'paClaim.accidentalMedicalExpenses.handlerMessage' | translate}}</div>
            </div>
          </div>
        </div>
        <BR/>
        <!-- bubble depreciation info -->
      </form>
    </div>
  </div>

  <div class="divider"></div>
  <br/>

  <ng-container *ngIf="this.claimPA.getAccidentalMedicalExpenses().getWasAdmitted()">
    <div class="row col-12">
      <div class="col-xl-9 col-lg-12 clinical-expense">
        <form [formGroup]="hospitalExpenseForm">
          <div formArrayName="items" *ngFor="let item of hospitalExpenseForm.get('items')['controls']; let i = index;">
            <div [formGroupName]="i">
              <div class="form-group click-more-content">
                <label>{{'paClaim.common.hospitalExpenseTitle' | translate}}&nbsp; {{i+1}}</label><button [hidden]="i==0" class="removeBtn" (click)="removeHospitalItem(i)">{{ 'claimSection.generalLabels.generalButtonLabels.remove' | translate}}</button><BR>
            
                  <qnect-ui [fieldId]="'PA_HOSPITAL_NAME'"
                  [frmArrayGroup]="hospitalExpenseForm"
                  [frmArrayName]="'items'"
                  frmArrayIndex="{{i}}"
                  name="hospitalName"></qnect-ui>

                  <qnect-ui [fieldId]="'PA_DATE_ADMISSION'"
                  [frmArrayGroup]="hospitalExpenseForm"
                  [frmArrayName]="'items'"
                  frmArrayIndex="{{i}}"
                  [dateRangeValidator]="getDatesForValidation(i, 'a')"
                  [claimsDateValidator]="claimPA.getAccidentDetails().getAccidentDate()"
                  name="dateAdmission"></qnect-ui>

                  <qnect-ui [fieldId]="'PA_DATE_DISCHARGE'"
                  [frmArrayGroup]="hospitalExpenseForm"
                  [frmArrayName]="'items'"
                  frmArrayIndex="{{i}}"
                  [dateRangeValidator]="getDatesForValidation(i, 'd')"
                  name="dateDischarge"></qnect-ui>

                  <qnect-ui [fieldId]="'PA_HOSPITAL_EXPENSE'"
                  [frmArrayGroup]="hospitalExpenseForm"
                  [frmArrayName]="'items'"
                  frmArrayIndex="{{i}}"
                  name="hospitalExpense"></qnect-ui>
                  
              </div>
              <div class="col-xl-2 col-lg-12">
                  &nbsp;
              </div>
            </div>
          </div>
        </form>
        <div class="addFile" (click)="addHospitalItem()">
          <em class="fas fa-plus"></em>
          <img src="assets/images/Add.svg" alt="plus" class="plus-img" />
          <span>{{ 'paClaim.accidentalMedicalExpenses.addHospitalExpense' | translate}}</span>
        </div>
      </div>
    <div class="col-lg-3 col-xl-3 col-md-12">
      &nbsp;
    </div>
  </div>
  </ng-container>
  <ng-container *ngIf="isNotNullOrUndefined(this.claimPA.getAccidentalMedicalExpenses().getWasAdmitted()) && !this.claimPA.getAccidentalMedicalExpenses().getWasAdmitted()">
    <div class="row col-12">
      <div class="col-xl-9 col-lg-12 clinical-expense">
        <form [formGroup]="clinicalExpenseForm">
          <div formArrayName="items" *ngFor="let item of clinicalExpenseForm.get('items')['controls']; let i = index;">
            <div [formGroupName]="i">
              <div class="form-group click-more-content">
                <label>{{'paClaim.common.clinicalExpenseTitle' | translate}}&nbsp; {{i+1}}</label><button [hidden]="i==0" class="removeBtn" (click)="removeClinicalItem(i)">{{ 'claimSection.generalLabels.generalButtonLabels.remove' | translate}}</button><BR>
            
                  <qnect-ui [fieldId]="'PA_DATE_VISIT'"
                  [frmArrayGroup]="clinicalExpenseForm"
                  [frmArrayName]="'items'"
                  frmArrayIndex="{{i}}"
                  [claimsDateValidator]="claimPA.getAccidentDetails().getAccidentDate()"
                  name="dateVisit"></qnect-ui>
                  
                  <qnect-ui [fieldId]="'PA_MEDICAL_ATTENTION'"
                  [frmArrayGroup]="clinicalExpenseForm"
                  [frmArrayName]="'items'"
                  frmArrayIndex="{{i}}"
                  name="medicalAttention"></qnect-ui>

                 <ng-container *ngIf="this.clinicalExpenseItems !== null && this.clinicalExpenseItems?.length > 0 &&
                     this.clinicalExpenseItems[i]?.getMedicalAttention() === 'Others'">
                   <qnect-ui [fieldId]="'PA_MEDICAL_ATTENTION_OTHERS'"
                            [frmArrayGroup]="clinicalExpenseForm"
                            [frmArrayName]="'items'"
                            frmArrayIndex="{{i}}"
                            name="medicalAttentionOthers"></qnect-ui>
                 </ng-container>
  
                  <qnect-ui [fieldId]="'PA_CLINICAL_EXPENSE'"
                  [frmArrayGroup]="clinicalExpenseForm"
                  [frmArrayName]="'items'"
                  frmArrayIndex="{{i}}"
                  name="clinicalExpense"></qnect-ui>
                  
              </div>
              <div class="col-xl-2 col-lg-12">
                  &nbsp;
              </div>
            </div>
          </div>
        </form>
        <div class="addFile" (click)="addClinicalItem()">
          <em class="fas fa-plus"></em>
          <img src="assets/images/Add.svg" alt="plus" class="plus-img" />
          <span>{{ 'paClaim.accidentalMedicalExpenses.addClinicExpense' | translate}}</span>
        </div>
      </div>
      <div class="col-lg-3 col-xl-3 col-md-12">
        &nbsp;
      </div>
    </div>
    <div class="col-lg-3 col-xl-3 col-md-12">
      &nbsp;
    </div>
    <div class="row col-12">
      <div class="col-xl-12 col-lg-12 clinical-expense">
        <div class="form-group">
          <qnect-ui #PA_FULLY_RECOVERED [fieldId]="'PA_FULLY_RECOVERED'" [formGroup]="clinicalExpenseForm" name="fullyRecovered"></qnect-ui>
        </div>
        <div class="form-group" *ngIf="claimPA.getAccidentalMedicalExpenses().getFullyRecovered() === false">
          <qnect-ui #PA_TREATMENT [fieldId]="'PA_TREATMENT'" [formGroup]="clinicalExpenseForm" name="treatment"></qnect-ui>
        </div>
      </div>
    </div>
  </ng-container>
<ng-container *ngIf="claim.isSGP()">
    <ng-container *ngIf="this.claimPA.getAccidentalMedicalExpenses().getWasAdmitted()">
        <div class="divider"></div>
        <div class="col-12">
            <h5>{{ 'paClaim.icu.title' | translate }}</h5>
            <br>
        </div>
        <div class="row col-12">
            <div class="col-lg-9 col-md-12">
                <form>
                    <div class="form-group">
                        <qnect-ui #PA_ICU_STAYEDIN [fieldId]="'PA_ICU_STAYEDIN'" [formGroup]="icuForm" name="stayedIn"></qnect-ui>
                    </div>
                    <ng-container *ngIf="this.claimPA.getAccidentalMedicalExpenses().getStayedIn()">
                        <div class="form-group">
                            <qnect-ui #PA_ICU_DATEFROM [fieldId]="'PA_ICU_DATEFROM'" [formGroup]="icuForm"
                                      [dateRangeValidator]="getICUDatesForValidation('a')" name="dateFrom"></qnect-ui>
                        </div>
                        <div class="form-group">
                            <qnect-ui #PA_ICU_DATETO [fieldId]="'PA_ICU_DATETO'" [formGroup]="icuForm" name="dateTo"
                                      [dateRangeValidator]="getICUDatesForValidation('d')"></qnect-ui>
                        </div>
                    </ng-container>
                </form>
            </div>
            <div class="col-lg-3 col-xl-3 col-md-12">
                &nbsp;
            </div>
        </div>
        <div class="divider"></div>
        <div class="col-12">
            <h5>{{ 'paClaim.outpatient.title' | translate }}</h5>
            <br>
        </div>
        <div class="row col-12">
            <div class="col-lg-12 col-md-12">
                <form>
                    <div class="form-group">
                        <qnect-ui #PA_ICU_HASOUTPATIENTCONSULTATIONS [fieldId]="'PA_ICU_HASOUTPATIENTCONSULTATIONS'" [formGroup]="outpatientForm" name="hasOutpatientConsultations"></qnect-ui>
                    </div>
                </form>
            </div>
        </div>
        <ng-container *ngIf="isNotNullOrUndefined(this.outpatientConsultation.getHasOutpatientConsultations()) &&  this.outpatientConsultation.getHasOutpatientConsultations()">
            <div class="row col-12">
                <div class="col-xl-9 col-lg-12 clinical-expense">
                    <form [formGroup]="outpatientConsultationClinicalExpenseForm">
                        <div formArrayName="items" *ngFor="let item of outpatientConsultationClinicalExpenseForm.get('items')['controls']; let i = index;">
                            <div [formGroupName]="i">
                                <div class="form-group click-more-content">
                                    <label>{{'paClaim.common.clinicalExpenseTitle' | translate}}&nbsp; {{i+1}}</label><button [hidden]="i==0" class="removeBtn" (click)="removeItemOutpatientConsultItem(i)">{{ 'claimSection.generalLabels.generalButtonLabels.remove' | translate}}</button><BR>

                                    <qnect-ui [fieldId]="'PA_DATE_VISIT_OUTPATIENT'"
                                              [frmArrayGroup]="outpatientConsultationClinicalExpenseForm"
                                              [frmArrayName]="'items'"
                                              frmArrayIndex="{{i}}"
                                              [claimsDateValidator]="claimPA.getAccidentDetails().getAccidentDate()"
                                              name="dateVisitOutpatient"></qnect-ui>

                                    <qnect-ui [fieldId]="'PA_MEDICAL_ATTENTION'"
                                              [frmArrayGroup]="outpatientConsultationClinicalExpenseForm"
                                              [frmArrayName]="'items'"
                                              frmArrayIndex="{{i}}"
                                              name="medicalAttention"></qnect-ui>

                                    <ng-container *ngIf="this.clinicalExpenseItems !== null && this.clinicalExpenseItems?.length > 0 &&
                                     this.clinicalExpenseItems[i]?.getMedicalAttention() === 'Others'">
                                        <qnect-ui [fieldId]="'PA_MEDICAL_ATTENTION_OTHERS'"
                                                  [frmArrayGroup]="outpatientConsultationClinicalExpenseForm"
                                                  [frmArrayName]="'items'"
                                                  frmArrayIndex="{{i}}"
                                                  name="medicalAttentionOthers"></qnect-ui>
                                    </ng-container>

                                    <qnect-ui [fieldId]="'PA_CLINICAL_EXPENSE'"
                                              [frmArrayGroup]="outpatientConsultationClinicalExpenseForm"
                                              [frmArrayName]="'items'"
                                              frmArrayIndex="{{i}}"
                                              name="clinicalExpense"></qnect-ui>

                                </div>
                                <div class="col-xl-2 col-lg-12">
                                    &nbsp;
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="addFile" (click)="addItemOutpatientConsultItem()">
                        <em class="fas fa-plus"></em>
                        <img src="assets/images/Add.svg" alt="plus" class="plus-img" />
                        <span>{{ 'paClaim.accidentalMedicalExpenses.addOutpatientConsultation' | translate}}</span>
                    </div>
                </div>
                <div class="col-lg-3 col-xl-3 col-md-12">
                    &nbsp;
                </div>
            </div>
            <div class="col-lg-3 col-xl-3 col-md-12">
                &nbsp;
            </div>
            <div class="row col-12">
                <div class="col-xl-12 col-lg-12 clinical-expense">
                    <div class="form-group">
                        <qnect-ui #PA_FULLY_RECOVERED [fieldId]="'PA_FULLY_RECOVERED'" [formGroup]="outpatientConsultationClinicalExpenseForm" name="fullyRecovered"></qnect-ui>
                    </div>
                    <div class="form-group" *ngIf="this.outpatientConsultation.getFullyRecovered() === false">
                        <qnect-ui #PA_TREATMENT [fieldId]="'PA_TREATMENT'" [formGroup]="outpatientConsultationClinicalExpenseForm" name="treatment"></qnect-ui>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container>
    <div class="divider"></div>
    <div class="col-12">
        <h5>{{ 'paClaim.medicalCertificate.title' | translate }}</h5>
        <br>
    </div>
    <div class="row col-12">
        <div class="col-lg-12 col-md-12">
            <div class="form-group">
                <qnect-ui #PA_WAS_MEDCERT_ISSUED [fieldId]="'PA_WAS_MEDCERT_ISSUED'" [formGroup]="ameForm"
                          name="wasMedCertIssued"></qnect-ui>
            </div>
        </div>
    </div>
    <ng-container *ngIf="this.claimPA.getAccidentalMedicalExpenses().getWasMedCertIssued()">
        <div class="row col-12">
            <div class="col-xl-9 col-lg-12">
                <form [formGroup]="medCertForm">
                    <div formArrayName="items" *ngFor="let item of medCertForm.get('items')['controls']; let i = index;">
                        <div [formGroupName]="i">
                            <div class="form-group click-more-content">
                                <label>{{'paClaim.medicalCertificate.title' | translate}} &nbsp; {{i+1}}</label><button [hidden]="i==0" class="removeBtn" (click)="removeMedCertItem(i)">{{ 'claimSection.generalLabels.generalButtonLabels.remove' | translate}}</button>
                                <br/><br/>
                                <label>{{'paClaim.medicalCertificate.periodOfMedLeave' | translate}}</label>

                                <qnect-ui [fieldId]="'PA_MEDCERT_PERIOD_FROM'"
                                          [frmArrayGroup]="medCertForm"
                                          [frmArrayName]="'items'"
                                          frmArrayIndex="{{i}}"
                                          [claimsDateValidator]="claimPA.getAccidentDetails().getAccidentDate()"
                                          name="periodFrom"></qnect-ui>

                                <qnect-ui [fieldId]="'PA_MEDCERT_PERIOD_TO'"
                                          [frmArrayGroup]="medCertForm"
                                          [frmArrayName]="'items'"
                                          frmArrayIndex="{{i}}"
                                          [claimsDateValidator]="$safeNavigationMigration(this.claimPA.getAccidentalMedicalExpenses()?.getMedicalCertificates()?.[i]?.getPeriodFrom())"
                                          name="periodTo"></qnect-ui>
                                <br/>

                                <qnect-ui [fieldId]="'PA_MEDCERT_PURPOSE'"
                                          [frmArrayGroup]="medCertForm"
                                          [frmArrayName]="'items'"
                                          frmArrayIndex="{{i}}"
                                          name="medCertPurpose"></qnect-ui>

                            </div>
                            <div class="col-xl-2 col-lg-12">
                                &nbsp;
                            </div>
                        </div>
                    </div>
                </form>
                <div *ngIf="medCertForm.get('items')?.length &lt; 5" class="addFile" (click)="addMedCertItem()">
                    <em class="fas fa-plus"></em>
                    <span>{{ 'paClaim.medicalCertificate.addAnotherPeriod' | translate}}</span>
                </div>
            </div>
            <div class="col-lg-3 col-xl-3 col-md-12">
                &nbsp;
            </div>
        </div>
    </ng-container>
</ng-container>
  <div *ngIf="!claim.isHKGorHGI()" class="submit-bar">
    <abandon-button></abandon-button>
    <a href="javascript:;" (click)="showModal()" class="Tertiary">{{ 'claimSection.generalLabels.generalButtonLabels.save' | translate}}</a>
    <button (click)="goToNext()" class="btn btn-primary float-right new-btn">&nbsp;{{ 'claimSection.generalLabels.generalButtonLabels.next' | translate}}&nbsp;<em class="fas fa-arrow-right"></em></button>
  </div>
  <app-save-box [showTotalBox]="showTotalBox" (childEvent)="getData($event)"></app-save-box>
</div>

